module.exports = __webpack_public_path__ + "static/media/TankYou-v2-white.0fd7fd9f.png";